"use client";

import React, { FC, useEffect } from "react";

interface Props {}
const ServiceWorker: FC<Props> = () => {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/service-worker.js")
        .then((registration) => console.log("scope is: ", registration))
        .catch((error) => {
          console.log(error);
        });
    }
  }, []);
  return <></>;
};
export default ServiceWorker;
